
export const Footer = () => {
  return (
    <footer>
      <p>Copyright 2023. All Rights Reserved</p>
    </footer>
  )
}
